import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=72f4cd30&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"
import style0 from "./Background.vue?vue&type=style&index=0&id=72f4cd30&prod&lang=css"
import style1 from "./Background.vue?vue&type=style&index=1&id=72f4cd30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f4cd30",
  null
  
)

export default component.exports